import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import * as dataLayer from '@classic/Foundation/Analytics/AnalyticsDataLayer'

export const trackFollowMeSortFeed = (sortItem: string): void =>
  trackFollowMeEvent({ interaction_type: 'Sort Feed', sortItem, location: getFollowMeLocation() })

export const trackFollowMeViewProfile = (): void =>
  trackFollowMeEvent({
    interaction_type: 'View Profile',
    location: getFollowMeLocation(),
    activeTab: 'Tips',
    activePill: 'Pending',
  })

export const trackFollowMeToggleFollow = (activeState: 'enable' | 'disable'): void =>
  trackFollowMeEvent({
    interaction_type: 'Follow User',
    location: getFollowMeLocation(),
    activeState,
  })

export const trackFollowMeCopyBet = (): void =>
  trackFollowMeEvent({
    interaction_type: 'Copy Bet',
    location: getFollowMeLocation(),
  })

export const trackFollowMeCopyBetError = (message: string): void =>
  trackFollowMeEvent({
    interaction_type: 'Copy Bet Error',
    message,
    location: getFollowMeLocation(),
  })

export const trackFollowMeNotificationToggle = (activeState: 'enable' | 'disable'): void =>
  trackFollowMeEvent({
    interaction_type: 'Set Notification',
    location: getFollowMeLocation(),
    activeState,
  })

export const trackFollowMeViewMyProfile = (): void =>
  trackFollowMeEvent({
    interaction_type: 'View My Profile',
    location: getFollowMeLocation(),
    activeTab: 'Tips',
    activePill: 'Pending',
  })

export const trackFollowMeEditMyProfile = (): void =>
  trackFollowMeEvent({
    interaction_type: 'Edit My Profile',
  })

export const trackFollowMeEditAvatar = (): void =>
  trackFollowMeEvent({
    interaction_type: 'Edit Avatar',
  })

export const trackFollowMeProfileUpdated = (): void =>
  trackFollowMeEvent({
    interaction_type: 'Profile Updated',
  })

export const trackFollowMeRandomiseAvatar = (): void =>
  trackFollowMeEvent({
    interaction_type: 'Randomise Avatar',
  })

export const trackFollowMeAvatarUpdated = (): void =>
  trackFollowMeEvent({
    interaction_type: 'Avatar Updated',
  })

export const trackFollowMeExpandSelection = (activeState: 'enable' | 'disable'): void =>
  trackFollowMeEvent({
    interaction_type: 'Expand Selection',
    location: getFollowMeLocation(),
    activeState,
  })

export const trackFollowMeProfileTabAndPillChange = (
  interaction_type: 'Tab Change' | 'Pill Change',
  activeTab: 'Tips' | 'Stats',
  activePill?: 'Pending' | 'Last 10' | 'My Copies'
): void =>
  trackFollowMeEvent({
    interaction_type,
    location: getFollowMeLocation(),
    activeTab,
    activePill,
  })

// ================
// Helper function
// ================
function trackFollowMeEvent({
  interaction_type = undefined,
  sortItem = undefined,
  location = undefined,
  activeState = undefined,
  message = undefined,
  activeTab = undefined,
  activePill = undefined,
}: {
  interaction_type?: string
  sortItem?: string
  location?: 'Explore' | 'Following' | 'My Profile' | 'User Profile'
  activeState?: 'enable' | 'disable'
  message?: string
  activeTab?: 'Tips' | 'Stats'
  activePill?: 'Pending' | 'Last 10' | 'My Copies'
}) {
  trackEvent(dataLayer.keys.followMe, {
    interaction_type: interaction_type,
    location: location,
    activeState: activeState,
    message: message,
    sortItem: sortItem,
    activeTab: activeTab,
    activePill: activePill,
  })
}

function getFollowMeLocation():
  | 'Explore'
  | 'Following'
  | 'My Profile'
  | 'User Profile'
  | undefined {
  const url = new URL(window.location.href)

  const tab = url.searchParams.get('tab')
  const pathname = url.pathname

  if (pathname === '/follow-me') {
    if (tab === 'explore' || !tab) return 'Explore'
    if (tab === 'following') return 'Following'
  }

  if (pathname === '/follow-me/my-profile') {
    return 'My Profile'
  }

  if (/^\/follow-me\/profile\/[a-zA-Z0-9-]+$/.test(pathname)) {
    return 'User Profile'
  }

  return undefined
}
